import Select from "@/components/Select";
import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import {
  teamAvailabilityStatusDefs,
  TeamAvailabilityStatus
} from "@velaro/velaro-component-lib";

export type TeamAvailabilityCondition = {
  status: TeamAvailabilityStatus;
  comparator: Comparator;
};

export function TeamAvailabilityEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const teamCondition = JSON.parse(
    condition.data || "{}"
  ) as TeamAvailabilityCondition;

  function update(data: TeamAvailabilityCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const validComparatorOptions: Record<string, string> = {
    equals: comparatorDefs.equals,
    notEquals: comparatorDefs.notEquals
  };

  return (
    <>
      <Select
        options={validComparatorOptions}
        value={teamCondition.comparator}
        onChange={(v) => update({ ...teamCondition, comparator: v })}
      />
      <Select
        options={teamAvailabilityStatusDefs}
        value={teamCondition.status}
        onChange={(v) => update({ ...teamCondition, status: v })}
      />
    </>
  );
}
